export default {
  navMenuItems: state => state.navMenuItems
}
